import get from 'lodash/get';
import {useEffect,useState} from 'react';
import {connect} from 'react-redux';
import {useNavigate, useSearchParams} from 'react-router-dom';

import useMFANeeded from '../../hooks/useMFANeeded';
import {useCreateMFACodeMutation, useClaimMFACodeMutation} from '../../redux/services/authApi';
import {useLazyGetCurrentUserQuery} from '../../redux/services/userApi';
import {setDeviceToken} from '../../redux/reducers/auth';
import MFAScreen from '../../components/auth/MFAScreen';
import AuthLayout from "../../components/auth/AuthLayout";

const handleSubmit = ({
  claimMFACode,
  next,
  _setDeviceToken,
  fetchUser
}) => async ({email, code}) => {
  const res = await claimMFACode({email, code});
  if (res.error) return;
  _setDeviceToken({
    deviceToken: get(res, 'data.data[0].device_token'),
    exp: get(res, 'data.data[0].expires_on'),
    deviceEmail: email,
  });
  const userRes = await fetchUser();
  next();
};

const handleResend = ({createMFACode, setResent}) => async ({email}) => {
  const res = await createMFACode({email});
  if (!res.error) setResent(true);
};

const MFAPage = props => {
  const navigate = useNavigate();
  const mfaNeeded = useMFANeeded();
  const [searchParams] = useSearchParams();
  const redirectPath = searchParams.get('redirectPath');
  const [resent, setResent] = useState(false);
  const [createMFACode, resendReq] = useCreateMFACodeMutation();
  const [claimMFACode, req] = useClaimMFACodeMutation();
  const [fetchUser] = useLazyGetCurrentUserQuery();
  useEffect(() => {
    if (!mfaNeeded) navigate(redirectPath);
  }, [mfaNeeded,navigate,redirectPath]);
  console.log('MFAPage.mfaNeeded', mfaNeeded);
  const childProps = {
    ...props,
    resent,
    errorMessage: (
      req.error
      ? 'Code was not accepted. Codes expire after 1 hour. Try generating a new code.'
      : (resendReq.error ? 'Email failed to send.' : null)
    ),
    onSubmit: formValues => handleSubmit({
      claimMFACode,
      next: () => navigate(redirectPath || '/'),
      _setDeviceToken: props.setDeviceToken,
      fetchUser,
    })(formValues),
    onResend: formValues => handleResend({
      createMFACode,
      setResent
    })(formValues),
  };

  return (
    <AuthLayout {...props}
                title="Verification Code"
                showLoginBtn={false}
    >
      <MFAScreen {...childProps} />
    </AuthLayout>
  );
};


const mapState = state => ({
  email: get(state, 'auth.email'),
});

const mapDispatch = dispatch => ({
  setDeviceToken: params => dispatch(setDeviceToken(params)),
});

export default connect(mapState, mapDispatch)(MFAPage);
